module.exports = __webpack_public_path__ + "static/img/success.b31f18d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/success.gif
// module id = 1524
// module chunks = 180